<template>
  <div>
    <cp-opinion-input
      :current-user="currentUser"
      :send="sendOpinion"
      style="margin-bottom: 10px"
      :name="name"
      :placeholder-status-post="placeholderStatusPost"
      :modalFeed="modalFeed"
    />
  </div>
</template>

<script>
import * as API from '../api/opinions';

export default {
  name: 'CpOpinionsContainer',
  components: {
    CpButton: require('../button'),
    CpImage: require('../image'),
    CpOpinionsItem: require('./opinions-item').default,
    CpOpinionInput: require('./opinion-input').default,
  },
  props: {
    opinionsCount: [Number, String],
    id: [String, Number],
    type: String,
    name: String,
    image: Object,
    currentUser: { type: Object, default: {} },
    placeholderStatusPost: { type: String },
    reload: Function,
    modalFeed: { type: Boolean, default: false },
  },
  data() {
    return {
      opinion: Object,
    };
  },
  methods: {
    async sendOpinion(type, { image, video, opinion, gif }) {
      await API.opinion(type, { opinion, image, video, gif, modalFeed: this.modalFeed })
        .then(response => {
          this.opinion = response.opinion;
          if (this.currentUser) {
            this.reload();
          } else {
            this.$emit('postButtonClicked', this.opinion.id);
          }
        })
        .catch(error => {
          if (!this.$root.authUser) {
            this.$root.redirectToLogin(window.location.href + '#feed');
          }
        });
    },
  },

  directives: {
    margin: require('../directives/margins').margin,
    marginBottom: require('../directives/margins').marginBottom,
    marginTop: require('../directives/margins').marginTop,
  },
};
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
.text-center {
  text-align: center;
}
.modal-content {
  max-width: 460px;
  padding: 40px 80px 30px;
  text-align: center;
}
.mt-10 {
  margin-top: 10px;
}
@media (max-width: 768px) {
  .modal-content {
    padding: 20px 40px;
  }
}
/* transition styles */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s ease-in-out;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
